export type FormatDateTimeProps = {
    locale?: string;
    date: Date | null;
    options?: Intl.DateTimeFormatOptions;
};

const defaultDateOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric', // Numeric representation of the year
    month: 'short', // Abbreviated month name
    day: '2-digit', // Two-digit representation of the day
    numberingSystem: 'latn', // Force latin numerals
    calendar: 'gregory', // Force Gregorian calendar
};

const defaultTimeOptions: Intl.DateTimeFormatOptions = {
    hour: '2-digit', // Two-digit representation of the hour
    minute: '2-digit', // Two-digit representation of the minute
    hourCycle: 'h23',
    numberingSystem: 'latn', // Force latin numerals
};

function format({ locale, date, options }: FormatDateTimeProps): string {
    if (!date) {
        return 'Invalid date';
    }
    return new Intl.DateTimeFormat(locale, options).format(date);
}

export function formatDate({ locale, date, options }: FormatDateTimeProps): string {
    const formatOptions = { ...defaultDateOptions, ...options };
    return format({ locale, date, options: formatOptions });
}

export function formatTime({ locale, date, options }: FormatDateTimeProps): string {
    const formatOptions = { ...defaultTimeOptions, ...options };
    return format({ locale, date, options: formatOptions });
}

export function formatDateTime({ locale, date, options }: FormatDateTimeProps): string {
    const formatOptions = { ...defaultDateOptions, ...defaultTimeOptions, ...options };
    return format({ locale, date, options: formatOptions });
}
